var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 121.86089238845145 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l121.86089 0l0 100.0l-121.86089 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l121.86089 0l0 100.0l-121.86089 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m92.57416 39.965744l0 0c0 -0.8030739 0.65102386 -1.4540977 1.4540939 -1.4540977l21.280785 0c0.38565063 0 0.7555084 0.15320206 1.0281982 0.4258957c0.27269745 0.27269745 0.4258957 0.6425514 0.4258957 1.028202l0 5.8162155c0 0.8030777 -0.65101624 1.4540977 -1.4540939 1.4540977l-21.280785 0c-0.80307007 0 -1.4540939 -0.65102005 -1.4540939 -1.4540977z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.57416 39.965744l0 0c0 -0.8030739 0.65102386 -1.4540977 1.4540939 -1.4540977l21.280785 0c0.38565063 0 0.7555084 0.15320206 1.0281982 0.4258957c0.27269745 0.27269745 0.4258957 0.6425514 0.4258957 1.028202l0 5.8162155c0 0.8030777 -0.65101624 1.4540977 -1.4540939 1.4540977l-21.280785 0c-0.80307007 0 -1.4540939 -0.65102005 -1.4540939 -1.4540977z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m44.899574 91.360466l0 0c-0.7915764 -0.7915726 -0.7915764 -2.074974 0 -2.8665466l20.234024 -20.234024c0.38012695 -0.38012695 0.8956909 -0.59368134 1.4332733 -0.59368134c0.5375824 0 1.0531464 0.21355438 1.4332733 0.59368134l5.732933 5.732933c0.7915802 0.7915726 0.7915802 2.074974 0 2.8665466l-20.23402 20.234024l0 0c-0.7915764 0.7915802 -2.074974 0.7915802 -2.8665504 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m44.899574 91.360466l0 0c-0.7915764 -0.7915726 -0.7915764 -2.074974 0 -2.8665466l20.234024 -20.234024c0.38012695 -0.38012695 0.8956909 -0.59368134 1.4332733 -0.59368134c0.5375824 0 1.0531464 0.21355438 1.4332733 0.59368134l5.732933 5.732933c0.7915802 0.7915726 0.7915802 2.074974 0 2.8665466l-20.23402 20.234024l0 0c-0.7915764 0.7915802 -2.074974 0.7915802 -2.8665504 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffff00",
    d: "m77.01782 17.115461l0 0c0.77697754 -0.77698326 2.0367203 -0.77698326 2.8136978 0l20.272911 20.27291c0.37312317 0.37312317 0.5827408 0.8791809 0.5827408 1.4068527c0 0.5276718 -0.20961761 1.0337334 -0.5827408 1.4068527l-5.6272354 5.627239c-0.77698517 0.77698517 -2.036728 0.77698517 -2.8137054 0l-20.272911 -20.27291c-0.77698517 -0.77698135 -0.77698517 -2.0367203 0 -2.8137035z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffff00",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m77.01782 17.115461l0 0c0.77697754 -0.77698326 2.0367203 -0.77698326 2.8136978 0l20.272911 20.27291c0.37312317 0.37312317 0.5827408 0.8791809 0.5827408 1.4068527c0 0.5276718 -0.20961761 1.0337334 -0.5827408 1.4068527l-5.6272354 5.627239c-0.77698517 0.77698517 -2.036728 0.77698517 -2.8137054 0l-20.272911 -20.27291c-0.77698517 -0.77698135 -0.77698517 -2.0367203 0 -2.8137035z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m3.0508072 61.181652l0 0c0 -1.0321541 0.83672595 -1.8688812 1.8688796 -1.8688812l28.931849 0c0.49565506 0 0.9710121 0.19689941 1.321495 0.54738235c0.35048294 0.35048294 0.54738235 0.82584 0.54738235 1.3214989l0 7.475292c0 1.0321503 -0.83672714 1.8688812 -1.8688774 1.8688812l-28.931849 0c-1.0321536 0 -1.8688796 -0.83673096 -1.8688796 -1.8688812z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m3.0508072 61.181652l0 0c0 -1.0321541 0.83672595 -1.8688812 1.8688796 -1.8688812l28.931849 0c0.49565506 0 0.9710121 0.19689941 1.321495 0.54738235c0.35048294 0.35048294 0.54738235 0.82584 0.54738235 1.3214989l0 7.475292c0 1.0321503 -0.83672714 1.8688812 -1.8688774 1.8688812l-28.931849 0c-1.0321536 0 -1.8688796 -0.83673096 -1.8688796 -1.8688812z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m35.720222 14.832937l0 0c0 -0.8653021 0.7014656 -1.5667677 1.5667686 -1.5667677l35.311214 0c0.41553497 0 0.81404877 0.16506958 1.107872 0.45889568c0.29382324 0.2938261 0.45889282 0.69233894 0.45889282 1.107872l0 6.26688c0 0.86530304 -0.7014618 1.5667686 -1.5667648 1.5667686l-35.311214 0c-0.86530304 0 -1.5667686 -0.7014656 -1.5667686 -1.5667686z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m35.720222 14.832937l0 0c0 -0.8653021 0.7014656 -1.5667677 1.5667686 -1.5667677l35.311214 0c0.41553497 0 0.81404877 0.16506958 1.107872 0.45889568c0.29382324 0.2938261 0.45889282 0.69233894 0.45889282 1.107872l0 6.26688c0 0.86530304 -0.7014618 1.5667686 -1.5667648 1.5667686l-35.311214 0c-0.86530304 0 -1.5667686 -0.7014656 -1.5667686 -1.5667686z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m82.31851 14.077641l0 0c0 -6.961077 5.6430664 -12.604145 12.604149 -12.604145l0 0c3.3428268 0 6.5487366 1.3279328 8.912476 3.6916685c2.3637314 2.3637357 3.6916656 5.5696497 3.6916656 8.912477l0 0c0 6.9610767 -5.6430664 12.604145 -12.604141 12.604145l0 0c-6.9610825 0 -12.604149 -5.6430683 -12.604149 -12.604145z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m82.31851 14.077641l0 0c0 -6.961077 5.6430664 -12.604145 12.604149 -12.604145l0 0c3.3428268 0 6.5487366 1.3279328 8.912476 3.6916685c2.3637314 2.3637357 3.6916656 5.5696497 3.6916656 8.912477l0 0c0 6.9610767 -5.6430664 12.604145 -12.604141 12.604145l0 0c-6.9610825 0 -12.604149 -5.6430683 -12.604149 -12.604145z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffff00",
    d: "m43.1144 49.01473l0 0c-1.9168549 -1.9168549 -1.9168549 -5.0246964 0 -6.941551l27.203457 -27.203457c0.92050934 -0.9205065 2.1689835 -1.4376421 3.4707718 -1.4376421c1.301796 0 2.55027 0.5171356 3.4707794 1.4376421l13.88269 13.8826885c1.9168549 1.9168568 1.9168549 5.0246944 0 6.941553l-27.20346 27.203453c-1.9168549 1.9168549 -5.0246925 1.9168549 -6.941551 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffff00",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m43.1144 49.01473l0 0c-1.9168549 -1.9168549 -1.9168549 -5.0246964 0 -6.941551l27.203457 -27.203457c0.92050934 -0.9205065 2.1689835 -1.4376421 3.4707718 -1.4376421c1.301796 0 2.55027 0.5171356 3.4707794 1.4376421l13.88269 13.8826885c1.9168549 1.9168568 1.9168549 5.0246944 0 6.941553l-27.20346 27.203453c-1.9168549 1.9168549 -5.0246925 1.9168549 -6.941551 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9900ff",
    d: "m25.853035 62.5355l0 0c-0.9741287 -0.9741287 -0.9746132 -2.5539856 -0.0010814667 -3.5287094l22.143824 -22.170998c0.4675064 -0.4680786 1.101696 -0.7311554 1.7630501 -0.7313576c0.6613579 -2.0599365E-4 1.2957077 0.2624855 1.7635002 0.730278l7.055046 7.055046c0.9741287 0.9741287 0.9746132 2.5539856 0.001083374 3.5287132l-22.143826 22.170998c-0.9735298 0.9747238 -2.5524216 0.97520447 -3.5265503 0.0010757446z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9900ff",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m25.853035 62.5355l0 0c-0.9741287 -0.9741287 -0.9746132 -2.5539856 -0.0010814667 -3.5287094l22.143824 -22.170998c0.4675064 -0.4680786 1.101696 -0.7311554 1.7630501 -0.7313576c0.6613579 -2.0599365E-4 1.2957077 0.2624855 1.7635002 0.730278l7.055046 7.055046c0.9741287 0.9741287 0.9746132 2.5539856 0.001083374 3.5287132l-22.143826 22.170998c-0.9735298 0.9747238 -2.5524216 0.97520447 -3.5265503 0.0010757446z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9900ff",
    d: "m56.272488 45.086636l0 0c0.9306412 -0.93063736 2.4395065 -0.93063736 3.3701477 0l21.354267 21.354267c0.44690704 0.44690704 0.69797516 1.0530472 0.69797516 1.6850739c0 0.63201904 -0.25106812 1.2381592 -0.69797516 1.6850662l-6.740097 6.740097c-0.93063354 0.93063354 -2.439499 0.93063354 -3.37014 0l-21.354267 -21.354267l0 0c-0.93063736 -0.9306412 -0.93063736 -2.4395065 0 -3.370144z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9900ff",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m56.272488 45.086636l0 0c0.9306412 -0.93063736 2.4395065 -0.93063736 3.3701477 0l21.354267 21.354267c0.44690704 0.44690704 0.69797516 1.0530472 0.69797516 1.6850739c0 0.63201904 -0.25106812 1.2381592 -0.69797516 1.6850662l-6.740097 6.740097c-0.93063354 0.93063354 -2.439499 0.93063354 -3.37014 0l-21.354267 -21.354267l0 0c-0.93063736 -0.9306412 -0.93063736 -2.4395065 0 -3.370144z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffff00",
    d: "m57.280872 14.837301l0 0c0 -0.86395836 0.7003784 -1.5643358 1.5643349 -1.5643358l13.75322 0c0.41488647 0 0.8127823 0.164814 1.1061554 0.45818424c0.29336548 0.2933693 0.4581833 0.69126415 0.4581833 1.1061516l0 6.2571564c0 0.86395836 -0.7003784 1.5643349 -1.5643387 1.5643349l-13.75322 0c-0.86395645 0 -1.5643349 -0.7003765 -1.5643349 -1.5643349z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffff00",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m57.280872 14.837301l0 0c0 -0.86395836 0.7003784 -1.5643358 1.5643349 -1.5643358l13.75322 0c0.41488647 0 0.8127823 0.164814 1.1061554 0.45818424c0.29336548 0.2933693 0.4581833 0.69126415 0.4581833 1.1061516l0 6.2571564c0 0.86395836 -0.7003784 1.5643349 -1.5643387 1.5643349l-13.75322 0c-0.86395645 0 -1.5643349 -0.7003765 -1.5643349 -1.5643349z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunner);
export default __webpack_public_path__ + "static/media/runner.138d51b27b19f4736b66d1fb700241c5.svg";
export { ForwardRef as ReactComponent };